import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, CircularProgress } from "@mui/material";
import CarrierNetworkActions from "./CarrierNetworkActions/CarrierNetworkActions";
import CarrierNetworkDetail from "./CarrierNetworkDetail/CarrierNetworkDetail";
import { CarrierService } from "../../../../services/CarrierService";
import { ActiveUserContext, AlertContext } from "../../../Dashboard/Dashboard";

export default function CarrierNetwork({ carrier, getCarrier, setIsUpdating }) {
  const { instance } = useMsal();
  const [networkStatus, setNetworkStatus] = useState("");
  const [networkStatusDetails, setNetworkStatusDetails] = useState({});
  const [canAddAsLead, setCanAddAsLead] = useState(false);
  const [networkUserId, setNetworkUserId] = useState("");
  const [carrierNetworkId, setCarrierNetworkId] = useState(0);
  const [networkUserName, setNetworkUserName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRemove, setCanRemove] = useState(false);
  const activeUser = useContext(ActiveUserContext);
  const { warning } = useContext(AlertContext);

  const statusIds = {
    open: "OPEN",
    lead: "LEAD",
    relationship: "RELATN"
  };

  const statusLabels = {
    "OPEN": "Open",
    "LEAD": "Lead",
    "RELATN": "Relationship"
  };

  const getNetworkStatus = () => {
    setIsLoading(true);

    CarrierService.GetNetworkStatus(instance, carrier.id, activeUser.userIdMcld).then(res => {
      setNetworkStatusDetails(res);
      setIsLoading(false);
    }).catch(error => {
      console.error(error);
      setIsLoading(false);
      warning(error);
    });
  };

  useEffect(() => {
    if (activeUser && activeUser.userIdMcld && carrier.id) {
      getNetworkStatus();
    }
  }, [activeUser]);

  useEffect(() => {
    if (
      activeUser &&
      activeUser.userIdMcld === networkUserId &&
      (networkStatus === statusIds.lead || networkStatus === statusIds.relationship)
    ) {
      setCanUpdate(true);
      setCanRemove(true);
    } else {
      setCanUpdate(false);
      setCanRemove(false);
    }
  }, [activeUser, networkStatus, networkUserId]);

  useEffect(() => {
    if (networkStatusDetails && Object.keys(networkStatusDetails).length !== 0) {
      setNetworkStatus(networkStatusDetails.pipelineStatus ? networkStatusDetails.pipelineStatus : statusIds.open);
      setCanAddAsLead(networkStatusDetails.canAddAsLead);
      setNetworkUserId(networkStatusDetails.carrierManagerId);
      setNetworkUserName(networkStatusDetails.carrierManagerName);
      setCarrierNetworkId(networkStatusDetails.carrierNetworkId);
    }
  }, [networkStatusDetails]);

  if (isLoading) {
    return (
      <Box sx={{ marginLeft: "30px", display: "flex", alignItems: "center" }}>
        <CircularProgress sx={{ color: "primary.60" }} size={22} />
      </Box>
    );
  } else {
    return (
      <Box sx={{ display: "block", textAlign: "right" }}>
        <CarrierNetworkActions
          networkStatus={networkStatus}
          statusIds={statusIds}
          statusLabels={statusLabels}
          canUpdate={canUpdate}
          canRemove={canRemove}
          setIsLoading={setIsLoading}
          getNetworkStatus={getNetworkStatus}
          carrier={carrier}
          activeUser={activeUser}
          networkUserId={networkUserId}
          carrierNetworkId={carrierNetworkId}
          getCarrier={getCarrier}
          setIsUpdating={setIsUpdating}
          canAddAsLead={canAddAsLead}
          networkUserName={networkUserName}
        />
        <CarrierNetworkDetail networkStatusDetails={networkStatusDetails} statusIds={statusIds} />
      </Box>
    );
  }
}

CarrierNetwork.propTypes = {
  carrier: PropTypes.object.isRequired,
  getCarrier: PropTypes.func.isRequired,
  setIsUpdating: PropTypes.func.isRequired
};